import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Container, Form, Button, Row, Col, Image, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import { ApiManager } from '../../core/api-manager';
import { Utils } from '../../core/utils';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faLocationDot, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { countries as countryOptions } from '../../data/countries';
import { italianProvinceOptions } from '../../data/italian-provinces';
import { useCandidatePrivacy } from '../../components/CandidatePrivacyModal';


export default function Login() {

    const { open: openCandidatePrivacy } = useCandidatePrivacy();
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.redirect;
    const [username, setUserName] = useState(null);
    const [password, setPassword] = useState(null);
    const [remember, setRemember] = useState(false)
    const [errors, setErrors] = useState('');

    // Registration state
    const [regName, setRegName] = useState('');
    const [regSurname, setRegSurname] = useState('');
    const [regEmail, setRegEmail] = useState('');
    const [regPassword, setRegPassword] = useState('');
    const [regPassword2, setRegPassword2] = useState('');
    const [regPhone, setRegPhone] = useState('');
    const [regCountry, setRegCountry] = useState('');
    const [regProvince, setRegProvince] = useState('');
    const [notifyApplications, setNotifyApplications] = useState(true);
    const [notifyPositions, setNotifyPositions] = useState(false);
    const [acceptPrivacy, setAcceptPrivacy] = useState(false);
    const [isAdult, setIsAdult] = useState(false);
    const [registering, setRegistering] = useState(false);

    // Auto-select provincia "Estero" when country != Italia
    useEffect(() => {
        if (regCountry && regCountry.toLowerCase() !== 'italia') {
            if (regProvince !== 'EE') setRegProvince('EE');
        } else {
            if (regProvince === 'EE') setRegProvince('');
        }
    }, [regCountry]);


    async function handleSubmit(e) {
        e.preventDefault();
        const valueRemember = remember ? 1 : 0;
        var response = await LoginManager.login(username, password, valueRemember);
        console.log(response, username, password);
        if (response.success === 1 && response.status === 200) {
            const name = response.body.name + ' ' + response.body.surname
            navigate(redirectTo || '/profile');
            toast.success('Benvenuto ' + name + '!', { theme: 'colored' });
        } else {
            toast.error(response.message, { theme: 'colored' })
        }

    }
    async function register(e) {
        e?.preventDefault();
        if (registering) return;
        if (!regName || !regSurname || !regEmail || !regPassword || !regPassword2) {
            toast.error('Inserire tutti i campi!', { theme: 'colored' });
            return;
        }
        if (regPassword !== regPassword2) {
            toast.error('Le password non coincidono', { theme: 'colored' });
            return;
        }
        if (regPassword.length < 6) {
            toast.error('La password deve essere di almeno 6 caratteri', { theme: 'colored' });
            return;
        }
        if (!acceptPrivacy || !isAdult) {
            toast.error('Accettare privacy e maggiore età', { theme: 'colored' });
            return;
        }

        setRegistering(true);
        const body = {
            name: regName,
            surname: regSurname,
            email: regEmail,
            username: regEmail,
            password: Utils.encrypt(regPassword),
            phone: regPhone,
            country: regCountry,
            province: regProvince,
            idUserGroup: 1,
            notificationsStatusJob: notifyApplications ? 1 : 0,
            notificationsNewJob: notifyPositions ? 1 : 0,
            privacyPolicy: acceptPrivacy
        };
        const res = await ApiManager.sendRequest('/public/do_register', body);
        setRegistering(false);
        if (res.success === 1 && res.status === 200) {
            toast.success('Utente creato con successo!', { theme: 'colored' });
            localStorage.setItem('ltsid', res.ltsid);
            localStorage.setItem('sid', res.sid);
            localStorage.setItem('userInfo', JSON.stringify(res.body));
            navigate(redirectTo || '/');
        } else {
            if (res.message === 'user.exist') {
                toast.error("Esiste già un'utente con questa email.", { theme: 'colored' });
            } else {
                toast.error('Errore in fase di registrazione', { theme: 'colored' });
            }
        }
    }

    return (
        <>

            <Container fluid>
                <Container fluid={'md'} className='pb-5'>
                    {/* Titolo pagina */}
                    <Row className='pt-5 pb-4'>
                        <Col>
                            <h1 style={{ color: '#0A2B5E' }}>{LanguageProvider.get('pages.login.heading')}</h1>
                        </Col>
                    </Row>

                    {/* Sezione Login */}
                    <Row className='align-items-center mb-5'>
                        <Col md={2} className='text-md-start text-center fw-semibold' style={{ color: '#0A2B5E' }}>{LanguageProvider.get('pages.login.login')}</Col>
                        <Col md={10}>
                            <Form onSubmit={handleSubmit}>
                                <Row className='g-4'>
                                    <Col md={6}>
                                        <Form.Control type='email' placeholder={LanguageProvider.get('pages.login.usernamePlaceholder')} onChange={e => setUserName(e.target.value)} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Control type='password' placeholder={LanguageProvider.get('pages.login.passwordPlaceholder')} onChange={e => setPassword(e.target.value)} />
                                    </Col>
                                </Row>
                                <Row className='mt-2 mb-3'>
                                    <Col>
                                        <Link to='/recover' style={{ color: '#2FAAE0' }}>Password dimenticata?</Link>
                                    </Col>
                                </Row>
                                <Row className='mt-2'>
                                    <Col>
                                        <Button type='submit' className='w-100' style={{ backgroundColor: '#2FAAE0', borderColor: '#2FAAE0' }}>
                                            Accedi <FontAwesomeIcon icon={faArrowRight} className='ms-2' />
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>

                    <hr className='my-4' />

                    {/* Sezione Registrazione */}
                    <Row className='align-items-center mt-4'>
                        <Col md={2} className='text-md-start text-center fw-semibold' style={{ color: '#0A2B5E' }}>{LanguageProvider.get('pages.login.register')}</Col>
                        <Col md={10}>
                            <Form onSubmit={register}>
                                <Row className='g-4'>
                                    <Col md={4}><Form.Control placeholder='Nome' value={regName} onChange={e => setRegName(e.target.value)} /></Col>
                                    <Col md={4}><Form.Control placeholder='Cognome' value={regSurname} onChange={e => setRegSurname(e.target.value)} /></Col>


                                    <Col md={4}><Form.Control placeholder={LanguageProvider.get('pages.login.phone')} value={regPhone} onChange={e => setRegPhone(e.target.value)} /></Col>
                                    <Col md={4}>
                                        <InputGroup>
                                            <InputGroup.Text style={{ background: 'transparent', borderRight: 'none' }}>
                                                <FontAwesomeIcon icon={faGlobe} />
                                            </InputGroup.Text>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    classNamePrefix='rs'
                                                    placeholder={LanguageProvider.get('pages.login.country')}
                                                    isClearable
                                                    isSearchable
                                                    options={countryOptions}
                                                    value={countryOptions.find(o => o.value === regCountry) || null}
                                                    onChange={(opt) => setRegCountry(opt ? opt.value : '')}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderLeft: 'none',
                                                            borderColor: '#ced4da',
                                                            boxShadow: state.isFocused ? '0 0 0 .25rem rgba(13,110,253,.25)' : 'none',
                                                            '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#ced4da' },
                                                            borderTopLeftRadius: 0,
                                                            borderBottomLeftRadius: 0,
                                                            minHeight: 38,
                                                        }),
                                                        container: (base) => ({ ...base, width: '100%' }),
                                                        valueContainer: (base) => ({ ...base }),
                                                    }}
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>
                                    <Col md={4}>
                                        <InputGroup>
                                            <InputGroup.Text style={{ background: 'transparent', borderRight: 'none' }}>
                                                <FontAwesomeIcon icon={faLocationDot} />
                                            </InputGroup.Text>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    classNamePrefix='rs'
                                                    placeholder={LanguageProvider.get('pages.login.province')}
                                                    isClearable
                                                    isSearchable
                                                    options={italianProvinceOptions}
                                                    value={italianProvinceOptions.find(o => o.value === regProvince) || null}
                                                    onChange={(opt) => setRegProvince(opt ? opt.value : '')}
                                                    isDisabled={regCountry && regCountry.toLowerCase() !== 'italia'}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderLeft: 'none',
                                                            borderColor: '#ced4da',
                                                            boxShadow: state.isFocused ? '0 0 0 .25rem rgba(13,110,253,.25)' : 'none',
                                                            '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#ced4da' },
                                                            borderTopLeftRadius: 0,
                                                            borderBottomLeftRadius: 0,
                                                            minHeight: 38,
                                                        }),
                                                        container: (base) => ({ ...base, width: '100%' }),
                                                        valueContainer: (base) => ({ ...base }),
                                                    }}
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>
                                    <Col md={4}><Form.Control type='email' placeholder='Email' value={regEmail} onChange={e => setRegEmail(e.target.value)} /></Col>

                                    <Col md={4}><Form.Control type='password' placeholder={LanguageProvider.get('pages.login.password')} value={regPassword} onChange={e => setRegPassword(e.target.value)} /></Col>
                                    <Col md={4}><Form.Control type='password' placeholder={LanguageProvider.get('pages.login.passwordRepeat')} value={regPassword2} onChange={e => setRegPassword2(e.target.value)} /></Col>

                                    <Col md={6} className='mt-4'>
                                        <Form.Check
                                            type='switch'
                                            id='switch-candidature'
                                            label={LanguageProvider.get('pages.login.notificationsApps')}
                                            checked={notifyApplications}
                                            onChange={e => setNotifyApplications(e.target.checked)}
                                        />
                                    </Col>
                                    <Col md={6} className='mt-4'>
                                        <Form.Check
                                            type='switch'
                                            id='switch-posizioni'
                                            label={LanguageProvider.get('pages.login.notificationsNew')}
                                            checked={notifyPositions}
                                            onChange={e => setNotifyPositions(e.target.checked)}
                                        />
                                    </Col>

                                    <Col xs={12} className='mt-4'>
                                        <Form.Check
                                            type='checkbox'
                                            checked={acceptPrivacy}
                                            onChange={e => setAcceptPrivacy(e.target.checked)}
                                            label={<span><strong>ACCETTAZIONE PRIVACY POLICY</strong><br />Ho letto la <a href={LanguageProvider.get('footerTexts.legal.privacyPolicyUrl')} target='_blank' rel='noreferrer'>Privacy Policy</a> e la <a href='/privacy-candidati' onClick={openCandidatePrivacy}>Privacy policy relativa ai candidati</a> e accetto il trattamento dei dati personali sensi dell'art. 3/456</span>}
                                        />
                                    </Col>
                                    <Col xs={12} className='mb-2'>
                                        <Form.Check
                                            type='checkbox'
                                            checked={isAdult}
                                            onChange={e => setIsAdult(e.target.checked)}
                                            label={<span><strong>DICHIARO DI ESSERE MAGGIORENNE</strong></span>}
                                        />
                                    </Col>

                                    <Col xs={12} className='mt-2'>
                                        <Button type='submit' className='w-100' style={{ backgroundColor: '#2FAAE0', borderColor: '#2FAAE0' }} disabled={registering}>
                                            {registering ? LanguageProvider.get('pages.login.registering') : (
                                                <>
                                                    {LanguageProvider.get('pages.login.registerCta')} <FontAwesomeIcon icon={faArrowRight} className='ms-2' />
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};
